// src/adminComponent/ViewAllCategories.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaSearch, FaTrashAlt, FaEdit, FaRuler } from "react-icons/fa";
import "../css/ViewAllCustomers.css"; // reuse same shared CSS

const ViewAllCategories = () => {
  const [allCategories, setAllCategories] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const admin_jwtToken = sessionStorage.getItem("admin-jwtToken");
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const resp = await axios.get("https://goldenhides.in/api/category/all");
        const data = resp.data || {};
        const list = data.categories || [];
        setAllCategories(list);
        setFiltered(list);
      } catch (err) {
        console.error("Failed to fetch categories", err);
        toast.error("Failed to load categories", { position: "top-center" });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // filter/search
  useEffect(() => {
    const term = (q || "").trim().toLowerCase();
    if (!term) {
      setFiltered(allCategories);
      return;
    }
    setFiltered(
      allCategories.filter((c) => {
        const name = String(c.title || "").toLowerCase();
        const desc = String(c.description || "").toLowerCase();
        const id = String(c.id || "");
        return name.includes(term) || desc.includes(term) || id.includes(term);
      })
    );
  }, [q, allCategories]);

  const confirmAndDelete = (categoryId) => {
    if (
      !window.confirm("Delete this category? This action cannot be undone.")
    ) {
      return;
    }
    deleteCategory(categoryId);
  };

  const deleteCategory = (categoryId) => {
    fetch(
      "https://goldenhides.in/api/category/delete?categoryId=" + categoryId,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + admin_jwtToken,
        },
      }
    )
      .then((result) => result.json())
      .then((res) => {
        if (res.success) {
          toast.success(res.responseMessage || "Category deleted", {
            position: "top-center",
            autoClose: 1000,
          });
          // remove deleted from local state for instant feedback
          setAllCategories((prev) => prev.filter((c) => c.id !== categoryId));
          setFiltered((prev) => prev.filter((c) => c.id !== categoryId));
        } else {
          toast.error(res.responseMessage || "Delete failed", {
            position: "top-center",
            autoClose: 1500,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Server error while deleting", { position: "top-center" });
      });
  };

  const updateCategory = (category) => {
    navigate("/admin/category/update", { state: category });
  };

  const checkAvailableSize = (category) => {
    navigate("/admin/category/sizes", { state: category });
  };

  return (
    <div className="mt-3">
      <div className="container">
        <div className="card form-card custom-bg shadow-lg">
          <div className="card-header d-flex align-items-center justify-content-between bg-color custom-bg-text">
            <div>
              <h3 className="mb-0">All Categories</h3>
              <small className="text-muted">
                Manage product categories & sizes
              </small>
            </div>

            <div className="d-flex align-items-center gap-2">
              <div className="search-input-wrapper">
                <FaSearch className="search-icon" />
                <input
                  type="search"
                  placeholder="Search by id, name or description"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  className="form-control small search-input"
                />
              </div>

              {/* <button
                className="btn btn-sm bg-color custom-bg-text"
                onClick={() => navigate("/admin/category/add")}
                title="Add new category"
              >
                Add Category
              </button> */}
            </div>
          </div>

          <div className="card-body" style={{ minHeight: "30vh" }}>
            {loading ? (
              <div className="text-center py-5 text-muted">
                Loading categories...
              </div>
            ) : filtered.length === 0 ? (
              <div className="text-center py-5 text-muted">
                No categories found.
              </div>
            ) : (
              <div className="customers-grid categories-grid">
                {filtered.map((category) => (
                  <article
                    className="customer-card category-card"
                    key={category.id}
                  >
                    <header className="customer-card-head">
                      <div className="avatar-circle category-avatar">
                        <span className="avatar-initials">
                          {String(category.title || "C")
                            .charAt(0)
                            .toUpperCase()}
                        </span>
                      </div>

                      <div className="customer-meta">
                        <div className="customer-name">{category.title}</div>
                        <div className="customer-email small text-muted">
                          ID: {category.id}
                        </div>
                      </div>

                      <div className="customer-badge small text-muted">
                        <span className="badge bg-light text-dark">
                          Category
                        </span>
                      </div>
                    </header>

                    <div className="customer-body">
                      <div className="info-row">
                        <div className="label">Description</div>
                        <div className="value address-muted">
                          {category.description || (
                            <span className="text-muted">—</span>
                          )}
                        </div>
                      </div>
                    </div>

                    <footer className="customer-card-footer d-flex align-items-center justify-content-between">
                      <div className="small text-muted">
                        {/* show createdAt if available */}
                        {category.createdAt
                          ? new Date(
                              Number(category.createdAt)
                            ).toLocaleDateString()
                          : ""}
                      </div>

                      <div className="card-actions">
                        <button
                          className="btn btn-sm btn-outline-secondary me-2"
                          onClick={() => checkAvailableSize(category)}
                          title="View sizes"
                        >
                          <FaRuler /> &nbsp; Sizes
                        </button>

                        {/* <button
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() => updateCategory(category)}
                          title="Update category"
                        >
                          <FaEdit />
                        </button> */}
                        {/* 
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => confirmAndDelete(category.id)}
                          title="Delete category"
                        >
                          <FaTrashAlt />
                        </button> */}
                      </div>
                    </footer>
                  </article>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllCategories;
